<template>
  <v-row>
    <v-col v-for="card in cards" :key="card.key" cols="12" md="4">
      <v-card class="trezo-card bg-white border-0 shadow-none border-radius mb-0 pa-4">
        <div class="d-flex align-center justify-space-between mb-1">
          <span class="text-body-2 text-medium-emphasis">{{ card.label }}</span>
          <span class="material-symbols-outlined text-medium-emphasis">{{ card.icon }}</span>
        </div>
        <div class="text-h5 font-weight-bold mb-1">{{ card.formatted }}</div>
        <div
          v-if="card.changePct !== null"
          class="text-body-2 mb-2"
          :class="card.changePct >= 0 ? 'text-success' : 'text-error'"
        >
          {{ card.changePct >= 0 ? '▲' : '▼' }}
          {{ Math.abs(card.changePct) }}%
          <span class="text-medium-emphasis">önceki döneme göre</span>
        </div>
        <div v-else class="text-body-2 text-medium-emphasis mb-2">Karşılaştırma verisi yok</div>
        <apexchart
          v-if="card.sparkline.length"
          type="area"
          height="40"
          :options="sparklineOptions(card.color)"
          :series="[{ name: card.label, data: card.sparkline }]"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { KpiStat } from '@/services/adminStatsApi'

const props = defineProps<{
  questions: KpiStat
  tokens: KpiStat
  rating: KpiStat
}>()

function formatToken(v: number | null): string {
  if (v === null) return '—'
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M'
  if (v >= 1_000) return Math.round(v / 1_000) + 'K'
  return v.toLocaleString('tr-TR')
}

const cards = computed(() => [
  {
    key: 'questions',
    label: 'Toplam Soru',
    icon: 'chat_bubble_outline',
    color: '#3b82f6',
    formatted: (props.questions.current ?? 0).toLocaleString('tr-TR'),
    changePct: props.questions.change_pct,
    sparkline: props.questions.sparkline ?? [],
  },
  {
    key: 'tokens',
    label: 'Toplam Token',
    icon: 'token',
    color: '#8b5cf6',
    formatted: formatToken(props.tokens.current),
    changePct: props.tokens.change_pct,
    sparkline: props.tokens.sparkline ?? [],
  },
  {
    key: 'rating',
    label: 'Ortalama Puan',
    icon: 'star',
    color: '#f59e0b',
    formatted: props.rating.current !== null ? `${props.rating.current} ★` : '—',
    changePct: props.rating.change_pct,
    sparkline: props.rating.sparkline ?? [],
  },
])

function sparklineOptions(color: string): ApexOptions {
  return {
    chart: {
      sparkline: { enabled: true },
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: { curve: 'smooth', width: 2 },
    colors: [color],
    fill: {
      type: 'gradient',
      gradient: { opacityFrom: 0.4, opacityTo: 0.0 },
    },
    tooltip: { enabled: false },
    dataLabels: { enabled: false },
    xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { show: false },
    grid: { show: false, padding: { top: 0, bottom: 0, left: 0, right: 0 } },
  }
}
</script>
